<template>
<transition name="fade">
  <div v-if="!state.loading" class="p-5 pt-0">

    <div class="d-flex flex-wrap flex-stack mb-5">

        <h2 class="fw-bold my-2 d-none text-uppercase text-dark">
          Informations pour la paye des collaborateurs
        </h2>
      </div>
      <div class="card d-none d-md-block">
          <div class="card-header border-0 p-4 mb-5">
            <SearchAndFilter
                ref="SearchAndFilter"
                :listInitial="state.initialMyList"
                :filters="tableFilters"
                :key="state.initialMyList"
                classSearch="h-40px"
                widthDecalage="-300"
                @returnSearch="state.mylist = $event"
                classSelect="mx-1"
            ></SearchAndFilter> 
        </div>
      </div>

      <div class="card mb-6" v-if="state.mylist && state.mylist.length">
        <div class="card-body p-0">
          <el-table :data="state.mylist" size="small" stripe>
            <el-table-column prop="emp_prenom_nom" label="Collaborateur" min-width="180" />
            <el-table-column prop="eem_libelle" label="Libellé" width="120" show-overflow-tooltip />
            <el-table-column label="Voiture" width="100">
              <template #default="{ row }">
                {{ row.emp_x_voiture == 1 ? 'Oui' : 'Non' }}
              </template>
            </el-table-column>
            <el-table-column prop="eem_usage_voiture_pro" label="Usage pro (%)" width="100" />
            <el-table-column prop="eem_usage_voiture_perso" label="Usage perso (%)" width="100" />
            <el-table-column label="Congés saisis" width="110">
              <template #default="{ row }">
                {{ row.eem_x_conges == 1 ? 'Oui' : 'Non' }}
              </template>
            </el-table-column>
            <el-table-column prop="eem_kms_mois" label="Compteur KM" width="100" />
            <el-table-column prop="eem_status" label="Statut" width="150" />
            <el-table-column label="Date" width="110">
              <template #default="{ row }">
                {{ toDate(row.eem_date) }}
              </template>
            </el-table-column>
            <el-table-column label="Actions" width="100" fixed="right">
              <template #default="{ row }">
                <button class="btn btn-sm btn-light-primary" @click="openEtatEmp(row.eem_seq)">
                  Ouvrir
                </button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- <div class="row g-6 g-xl-9" v-if="state.mylist && state.mylist.length > 0">
        <div class="col-sm-6 col-xl-4 col-xxl-3" v-for="eem in state.mylist" :key="eem.eem_seq">
          <div class="card h-100">
            <CardEtatEmp
              card-classes="h-100 border-hover"
              :eem_libelle="eem.eem_libelle"
              color="primary"
              :eem_status="eem.eem_status"
              :emp_prenom_nom="eem.emp_prenom_nom"
              footer-text=""
              arrow="Up-right"
              :indicator-label="`Créee le ${toDate(eem.eem_date)}`"
              @click="openEtatEmp(eem.eem_seq)" 
              :all="true"
            ></CardEtatEmp>
          </div>
        </div>

      </div> -->

      <el-drawer v-model="state.openCloseEtatAddEdit" :with-header="false" size="900px" modal-class="modal-transp" :lock-scroll="false" :show-close="false">
        <EtatAddEdit apiName="getEtatEmp" :idEtat="state.EtatAddEdit" :isOpen="state.openCloseEtatAddEdit" :key="state.openCloseEtatAddEdit" @refresh="refresh(true)" @closeEtatAddEdit="state.openCloseEtatAddEdit = 0"/>
      </el-drawer>

    </div>
  </transition>
</template>
  
  <script lang="ts">
  import { defineComponent, ref, onMounted, reactive } from "vue";
  import mAxiosApi from "@/api";
  import * as moment from "moment";
  // import CardEtatEmp from "./CardEtatEmp.vue";
  import EtatAddEdit from "./EtatAddEdit.vue";
  import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
  import SearchAndFilter from "@/views/still/search_and_filters.vue";
  import { useRouter } from "vue-router";
   
  export default defineComponent({
    name: "General",
    components : {
        EtatAddEdit,
        SearchAndFilter
    },
    setup() {

    const dialogImageUrl = ref('')
    const dialogVisible = ref(false)
    const disabled = ref(false)

    const state = reactive({
        mylist : {} as any,
        EtatAddEdit : 0,
        openCloseEtatAddEdit : 0,
        loading : true,
        initialMyList: {} as any,
        search : 0,
    });

    const tableFilters = ref([]) as any;

    const router = useRouter();

    onMounted(() => {
      setCurrentPageBreadcrumbs("Etat mensuel", ["Pages", "Profile"]);

      console.log('list', state.mylist.eem_emp_prenom_nom);

      tableFilters.value.push({ name: "Collaborateur", key: "emp_prenom_nom", label: "emp_prenom_nom" });
      tableFilters.value.push({ name: "Statut", key: "eem_status", label: "eem_status" });
      refresh();

      if (router.currentRoute.value.params.otherparam) {
        openEtatEmp(Number(router.currentRoute.value.params.otherparam));
      } 

      state.loading = false;

    });

      const toDate = (d) => {
        return moment.default(d).format("DD.MM.YYYY");
      };


      const openEtatEmp = (id = 0) =>{
        state.EtatAddEdit = id;
        state.openCloseEtatAddEdit = 1;
      }


      const SearchAndFilter = ref(null);


      const refresh = async (update = false, idEtat = 0) => {
        const getEtatEmp = await mAxiosApi.prototype.getAxios("/getAllEtatEmp");
        if (!update) {
          state.mylist = getEtatEmp.results;
          state.initialMyList = state.mylist;

          console.log('list', state.mylist);
        } else {
          (SearchAndFilter.value as any).searchAllItems("", getEtatEmp.results);
        }


      };
     
      return {
          disabled,
          dialogImageUrl,
          dialogVisible,
          state,
          toDate,
          openEtatEmp,
          refresh,
          tableFilters,
          SearchAndFilter
      };
    },
  });
  </script>